import { ReportType } from "../reportype";

export class AttestationRequest {
    public ReportType: ReportType;
    public CollectionName: string;
    public ReportPeriod: string;
    public PcpTIN: string;
    public PcpId: string;
  }
  